import { render, staticRenderFns } from "./InvestorOnboardingName.vue?vue&type=template&id=2e499384&"
import script from "./InvestorOnboardingName.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports